// pages/portal/conversion-history.tsx
import PortalRedirect from '../../components/portal/layout/portal-redirect.component';

/**
 * Legacy route — redirects to /portal/conversions per Phase 3 IA.
 * Kept for at least 30 days after Phase 6 flag flip; delete after.
 */
export default function ConversionHistoryRedirect() {
    return <PortalRedirect to="/portal/conversions" />;
}
